import { useQuery } from "@tanstack/react-query";
import { matchesApi } from "../../api/matches";
import { normalizeId, type MaybeId } from "./queryKeyUtils";

export const matchKeys = {
  all: ["matches"] as const,
  detail: (id: MaybeId) => ["matches", "detail", normalizeId(id)] as const,
};

export const useMatchDetail = (id: MaybeId) =>
  useQuery({
    queryKey: matchKeys.detail(id),
    queryFn: () => matchesApi.getDetail(id!),
    enabled: id != null,
  });
